<template>
    <!-- 
        Quick-fetching-card

        Props: 
			fetchingAPI: (Opcional, Default inherit)
				URL for table/data fetching

			header: (Opcional, Default inherit)
				Header title

			footer: (Opcional, Default empty)
				Footer content text

        Version 1.4
        Convention simplification

        Version 1.3j
        Naming simplification.

        Version 1.2
        It can be configured with props.


        Version 1.0
        Quick fetching card allow you to a fast setting up for any kind of content with data preload.
        
        @Version 1.0
        @Author Daniel Lepe
        -->
	<div :id="name">

		<b-card no-body>

            <template v-slot:header>
				<b-row align-h="between">

					<b-col md="auto" v-if="!!header">
						<h6 class="mt-2 mb-2">{{header}}</h6>
					</b-col>

					<b-col>
						<div tabindex="-1" role="group">
							<div role="group" class="input-group">
                                <input type="text" v-model="term" @keyup.enter="reload()" placeholder="Search" class="form-control" />
								<div class="input-group-append">
									<button v-if="!!term" type="button" class="btn btn-secondary" @click="term = ''; reload();">
										<i class="fa fa-times"></i>
									</button>
									<button type="button" class="btn btn-secondary" @click="reload()" :disabled="!term">
										<i class="fa fa-search"></i>
									</button>
								</div>
							</div>
						</div>
					</b-col>

					<b-col md="auto" class="align-right">
						<ui-edit-auto-modal key="new" v-model="form" :refresh="reload" :formArchetype="formArchetype" ref="main" :label="newButtonLabel" :handler="'define/source/' + definerSource " apply-button="Apply" size="md" :allowDelete="false"/>
					</b-col>

				</b-row>
			</template>

			<div v-if="isLoading">
				<div class="text-center p-5">
					<b-spinner variant="primary" />
				</div>
			</div>

            <div v-else-if="!items.length" class="pt-4 pl-4 pr-4  pb-0">
                <b-jumbotron :lead="emptyLead">
                    <p>Try later</p>
                    <b-button variant="primary" @click="reload()">Reload</b-button>
                </b-jumbotron>
            </div>

			<b-table v-else class="animated fadeIn" responsive :items="items" :fields="captions">

				<template #cell(_)="data">
					<ui-edit-auto-modal label="Edit"  size="md" v-model="form"  :handler="'define/source/' + definerSource + '/' + data.item.id" :form-archetype="formArchetype" :refresh="reload" />
				</template>

			</b-table>

			<template v-slot:footer v-if="(!isLoading && items.length)">
				<b-row>
					<b-col v-if="!hideFooter">
						<p class="text-center p-0 m-0 mt-1">
                            <strong>Page {{currentPage}} of {{Math.ceil(itemsCount / perPage)}}</strong> 
							(Showing
							<strong>{{items.length}} records</strong>
							from {{itemsCount}} in total)
						</p>
					</b-col>
					<b-col>
						<b-pagination class="p-0 m-0" v-model="currentPage" :total-rows="itemsCount" :per-page="perPage" align="center" prev-text="Back" next-text="Next" />
					</b-col>
					<b-col cols="1" v-if="!hideFooter">
						<b-card-text class="text-right">
							<b-button @click="reload()" variant="outline-primary" key="fa-refresh">
								<i class="fa fa-refresh" aria-hidden="true"></i>
							</b-button>
						</b-card-text>
					</b-col>
				</b-row>
			</template>
		</b-card>

	</div>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'

let name = "QuickFetchingCard",
    newButtonLabel = 'New',
    emptyLead =  'Data not found',
	fetchedData = {},
	header = '',
	footer = null,
	fieldsConfg = [
		{key: '_'}
	],
	fetchingAPI = null;

export default {
	name,

	props: {
		definerSource: {
			type: String,
			required: true
		},	
		formArchetype: {
			type: [Array, Object],
			required: true
		},
        hideFooter: {
            type: Boolean,
            default: false,
        },
        passionsId: {
            type: [String, Array]
        },
		fetchingAPI: {
			type: String,
			default: () => { return fetchingAPI }
		},
		header: {
			type: String,
			default: () => { return header }
		},
		perPage: {
			type: Number,
			default: 20,
		},
		fieldsConfg: {
			type: Array,
			default: () => { return fieldsConfg }
		},
		footer: {
			type: String,
			default: () => { return footer }
		}
	},
	
	computed: {
		// formArchetype () {
		// 	return [
		// 		{
		// 			key: "id",
		// 			type: 'hidden', // [hidden|number|price|phone|textarea|positivo|password|email]
		// 		},
		// 		{
		// 			key: "discipline",
		// 		},
		// 		{
		// 			key: "estatus",
		// 			type: 'select',
		// 			options: [ 'Active','Inactive' ],
		// 			default: 'Actvie'
		// 		},
		// 		{
        //             key: 'passions_id',
        //             type: 'hidden',
        //             default: this.passionsId
		// 		}
		// 	]
		// },
        dynamicAPI(){
            return  this.fetchingAPI + ((this.passionsId) ? ('passions_id:' + this.passionsId) : '1:1');
        },
		sourceURI() {
			let init = this.dynamicAPI + "/" + this.perPage + "/" + this.currentPage;
			if (!!this.term) {
				init += "/" + this.term;
			} else if (!this.term || this.term == "s") {
				init += "/@";
			}
			return init;
		},
		captions: function () {
			return this.fieldsConfg;
		},
		newItem() {
			return {
				name: this.newItemName,
			};
		}
	},
	
	data: () => {
		return {
			name, newButtonLabel,
            emptyLead,
			form: {
				id: null
			},
			isEditing: false,
			currentPage: 1,
			items: [],
			itemsCount: 0,
			term: null,
			isLoading: false,
			fieldsConfg,
			fetchedData,
			asides: {
				recargaAmount: 0,
				ofertaspublicas: []
			}
		}
	},
	
	methods: {
		async reload(){
			this.isLoading = true
			await this.loadUp()
			this.isLoading = false
		},
		async loadUp(){
			try {
				let response = await axios.get(this.sourceURI)
				this.items = response.data.rows;
				this.itemsCount = response.data.count;
				this.loading = false;
				// ANALIZA SI HAY MENSAJES PARA EL USUARIO, duración extendia.
				// this.fetchedData = response.data
			} catch (error) {
				console.error(error)
			}
		}
	},

	watch: {
		'form.id'(){
			if(this.form.id){
				this.isEditing = true;
			} else {
				this.isEditing = false;
			}
		},
		currentPage(a, b) {
			this.reload();
		},
		'$route'(){
			this.loadUp()
		}
	},

	mounted() {
		if(!!this.fetchingAPI)
			this.reload()
	}
};
</script>

<style lang="less" scoped>
    .api-img {
        width: 7em;
        height: 7em;
    }
</style>